import {HTTP} from '@/services/HttpServices';
import {FilterData} from '@/components/filter/FilterModel';
import {DateTime} from 'luxon';

/** Gets a single alert's details (including locations) from the server.
 * @param memberAlertId represents the primary key of the member alert to get. */
export async function getAlert(memberAlertId: number | string): Promise<any> {
    const data = await HTTP.get('/member-alerts/details/' + memberAlertId);
    return data.payload;
}

export async function getAlerts(searchTerm: string, filterData: FilterData): Promise<any> {
    let queryParams = `searchTerm=${searchTerm}`;
    if (filterData.startDate) {
        const startDate = DateTime.fromISO(filterData.startDate, { zone: 'America/Chicago' }).startOf('day');
        queryParams += `&startDate=${startDate.toISO()}`;
    }
    if (filterData.endDate) {
        const endDate = DateTime.fromISO(filterData.endDate, { zone: 'America/Chicago' }).endOf('day');
        queryParams += `&endDate=${endDate.toISO()}`;
    }
    const data = await HTTP.get(`/member-alerts?${queryParams}`);
    return data.payload;
}

/** Creates a new member alert on the server.
 * @param memberAlert represents the member alert data the new member alert should have.
 * @param mals represents the member alert locations the new member alert should be associated with. */
export async function createAlert(memberAlert: any): Promise<any> {
    /* The server side expects only the locations' primary keys to be at alert.locations. */
    const data = await HTTP.post('/admin/member-alerts', memberAlert);
    return data.payload[0];
}

/** Updates an existing member alert on the server.
 * @param memberAlert represents the member alert data the updated member alert should have.
 * @param mals represents the member alert locations the updated member alert should be associated with. */
export async function updateAlert(memberAlert: any): Promise<void> {
    /* The server side expects only the locations' primary keys to be at alert.locations. */
    const data = await HTTP.put('/admin/member-alerts/' + memberAlert.alertId, memberAlert);
}

/** Gets up to 15 possible member alert locations from the server. Locations are expected to grow but there shouldn't be more than a dozen locations that member alerts get displayed at. If there are more than a dozen perhaps there should be a review of why that is the case. */
export async function loadMemberAlertLocations(): Promise<any> {
    const data = await HTTP.get('/member-alert-locations?limit=15&offset=0');
    return data.payload;
}

/** Deletes a member alert on the server.
 * @param memberAlert represents the member alert data that identifies the member alert to be removed from the server. */
export async function deleteMemberAlert(memberAlert: any): Promise<any> {
    const data = await HTTP.httpDelete('/admin/member-alerts/' + memberAlert.alertId);
    return data.payload;
}
